"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NebraskaColors = void 0;
var NebraskaColors;
(function (NebraskaColors) {
    NebraskaColors["asset01"] = "var(--asset-01)";
    NebraskaColors["asset02"] = "var(--asset-02)";
    NebraskaColors["asset03"] = "var(--asset-03)";
    NebraskaColors["asset04"] = "var(--asset-04)";
    NebraskaColors["asset05"] = "var(--asset-05)";
    NebraskaColors["asset06"] = "var(--asset-06)";
    NebraskaColors["asset07"] = "var(--asset-07)";
    NebraskaColors["asset08"] = "var(--asset-08)";
    NebraskaColors["asset09"] = "var(--asset-09)";
    NebraskaColors["asset10"] = "var(--asset-10)";
    NebraskaColors["asset11"] = "var(--asset-11)";
    NebraskaColors["asset12"] = "var(--asset-12)";
    NebraskaColors["asset13"] = "var(--asset-13)";
    NebraskaColors["asset14"] = "var(--asset-14)";
    NebraskaColors["asset15"] = "var(--asset-15)";
    NebraskaColors["assetFixedIncome"] = "var(--asset-fixed-income)";
    NebraskaColors["assetMultimarket"] = "var(--asset-multimarket)";
    NebraskaColors["assetOthers"] = "var(--asset-others)";
    NebraskaColors["assetStocks"] = "var(--asset-stocks)";
    NebraskaColors["aurora100"] = "var(--aurora-100)";
    NebraskaColors["aurora200"] = "var(--aurora-200)";
    NebraskaColors["aurora300"] = "var(--aurora-300)";
    NebraskaColors["aurora400"] = "var(--aurora-400)";
    NebraskaColors["aurora500"] = "var(--aurora-500)";
    NebraskaColors["aurora600"] = "var(--aurora-600)";
    NebraskaColors["aurora700"] = "var(--aurora-700)";
    NebraskaColors["aurora800"] = "var(--aurora-800)";
    NebraskaColors["backgroundHover"] = "var(--background-hover)";
    NebraskaColors["backgroundOverlay"] = "var(--background-overlay)";
    NebraskaColors["backgroundPrimary"] = "var(--background-primary)";
    NebraskaColors["backgroundQuartenary"] = "var(--background-quartenary)";
    NebraskaColors["backgroundSecondary"] = "var(--background-secondary)";
    NebraskaColors["backgroundTertiary"] = "var(--background-tertiary)";
    NebraskaColors["baseDisabled"] = "var(--base-disabled)";
    NebraskaColors["baseOverDisabled"] = "var(--base-over-disabled)";
    NebraskaColors["baseOverSecondary"] = "var(--base-over-secondary)";
    NebraskaColors["basePrimary"] = "var(--base-primary)";
    NebraskaColors["basePrimaryDarken"] = "var(--base-primary-darken)";
    NebraskaColors["baseSecondary"] = "var(--base-secondary)";
    NebraskaColors["baseSecondaryActive"] = "var(--base-secondary-active)";
    NebraskaColors["baseSecondaryDarken"] = "var(--base-secondary-darken)";
    NebraskaColors["baseSecondaryHover"] = "var(--base-secondary-hover)";
    NebraskaColors["baseSelect"] = "var(--base-select)";
    NebraskaColors["baseSelectDarken"] = "var(--base-select-darken)";
    NebraskaColors["benchmark01"] = "var(--benchmark-01)";
    NebraskaColors["benchmark02"] = "var(--benchmark-02)";
    NebraskaColors["benchmark03"] = "var(--benchmark-03)";
    NebraskaColors["benchmark04"] = "var(--benchmark-04)";
    NebraskaColors["benchmark05"] = "var(--benchmark-05)";
    NebraskaColors["benchmarkCdi"] = "var(--benchmark-cdi)";
    NebraskaColors["benchmarkInterest"] = "var(--benchmark-interest)";
    NebraskaColors["benchmarkIpca"] = "var(--benchmark-ipca)";
    NebraskaColors["benchmarkSavings"] = "var(--benchmark-savings)";
    NebraskaColors["brandLink"] = "var(--brand-link)";
    NebraskaColors["brandOverPrimary"] = "var(--brand-over-primary)";
    NebraskaColors["brandPrimary"] = "var(--brand-primary)";
    NebraskaColors["brandPrimaryActive"] = "var(--brand-primary-active)";
    NebraskaColors["brandPrimaryDarken"] = "var(--brand-primary-darken)";
    NebraskaColors["brandPrimaryHover"] = "var(--brand-primary-hover)";
    NebraskaColors["brandSecondary"] = "var(--brand-secondary)";
    NebraskaColors["brandSecondaryDarken"] = "var(--brand-secondary-darken)";
    NebraskaColors["businessLink"] = "var(--business-link)";
    NebraskaColors["businessOverPrimary"] = "var(--business-over-primary)";
    NebraskaColors["businessPrimary"] = "var(--business-primary)";
    NebraskaColors["businessPrimaryActive"] = "var(--business-primary-active)";
    NebraskaColors["businessPrimaryDarken"] = "var(--business-primary-darken)";
    NebraskaColors["businessPrimaryHover"] = "var(--business-primary-hover)";
    NebraskaColors["businessSecondary"] = "var(--business-secondary)";
    NebraskaColors["businessSecondaryDarken"] = "var(--business-secondary-darken)";
    NebraskaColors["carvao25"] = "var(--carvao-25)";
    NebraskaColors["carvao500"] = "var(--carvao-500)";
    NebraskaColors["cashLink"] = "var(--cash-link)";
    NebraskaColors["cashOverPrimary"] = "var(--cash-over-primary)";
    NebraskaColors["cashPrimary"] = "var(--cash-primary)";
    NebraskaColors["cashPrimaryActive"] = "var(--cash-primary-active)";
    NebraskaColors["cashPrimaryDarken"] = "var(--cash-primary-darken)";
    NebraskaColors["cashPrimaryHover"] = "var(--cash-primary-hover)";
    NebraskaColors["cashSecondary"] = "var(--cash-secondary)";
    NebraskaColors["cashSecondaryDarken"] = "var(--cash-secondary-darken)";
    NebraskaColors["cereja100"] = "var(--cereja-100)";
    NebraskaColors["cereja200"] = "var(--cereja-200)";
    NebraskaColors["cereja300"] = "var(--cereja-300)";
    NebraskaColors["cereja400"] = "var(--cereja-400)";
    NebraskaColors["cereja500"] = "var(--cereja-500)";
    NebraskaColors["cereja600"] = "var(--cereja-600)";
    NebraskaColors["cereja700"] = "var(--cereja-700)";
    NebraskaColors["cereja800"] = "var(--cereja-800)";
    NebraskaColors["ceu100"] = "var(--ceu-100)";
    NebraskaColors["ceu200"] = "var(--ceu-200)";
    NebraskaColors["ceu300"] = "var(--ceu-300)";
    NebraskaColors["ceu400"] = "var(--ceu-400)";
    NebraskaColors["ceu500"] = "var(--ceu-500)";
    NebraskaColors["ceu600"] = "var(--ceu-600)";
    NebraskaColors["ceu700"] = "var(--ceu-700)";
    NebraskaColors["ceu800"] = "var(--ceu-800)";
    NebraskaColors["cinza0"] = "var(--cinza-0)";
    NebraskaColors["cinza100"] = "var(--cinza-100)";
    NebraskaColors["cinza1000"] = "var(--cinza-1000)";
    NebraskaColors["cinza20"] = "var(--cinza-20)";
    NebraskaColors["cinza200"] = "var(--cinza-200)";
    NebraskaColors["cinza25"] = "var(--cinza-25)";
    NebraskaColors["cinza300"] = "var(--cinza-300)";
    NebraskaColors["cinza400"] = "var(--cinza-400)";
    NebraskaColors["cinza50"] = "var(--cinza-50)";
    NebraskaColors["cinza500"] = "var(--cinza-500)";
    NebraskaColors["cinza600"] = "var(--cinza-600)";
    NebraskaColors["cinza70"] = "var(--cinza-70)";
    NebraskaColors["cinza700"] = "var(--cinza-700)";
    NebraskaColors["cinza800"] = "var(--cinza-800)";
    NebraskaColors["cinza900"] = "var(--cinza-900)";
    NebraskaColors["cinza950"] = "var(--cinza-950)";
    NebraskaColors["cinzaDark20"] = "var(--cinza-dark-20)";
    NebraskaColors["dividerNavbar"] = "var(--divider-navbar)";
    NebraskaColors["dividerOpacity"] = "var(--divider-opacity)";
    NebraskaColors["dividerPrimary"] = "var(--divider-primary)";
    NebraskaColors["duna100"] = "var(--duna-100)";
    NebraskaColors["duna200"] = "var(--duna-200)";
    NebraskaColors["duna300"] = "var(--duna-300)";
    NebraskaColors["duna400"] = "var(--duna-400)";
    NebraskaColors["duna500"] = "var(--duna-500)";
    NebraskaColors["duna600"] = "var(--duna-600)";
    NebraskaColors["duna700"] = "var(--duna-700)";
    NebraskaColors["duna800"] = "var(--duna-800)";
    NebraskaColors["elementAlpha"] = "var(--element-alpha)";
    NebraskaColors["elementDisabled"] = "var(--element-disabled)";
    NebraskaColors["elementNegative"] = "var(--element-negative)";
    NebraskaColors["elementOnError"] = "var(--element-on-error)";
    NebraskaColors["elementOnSuccess"] = "var(--element-on-success)";
    NebraskaColors["elementOverImage"] = "var(--element-over-image)";
    NebraskaColors["elementPlaceholder"] = "var(--element-placeholder)";
    NebraskaColors["elementPrimary"] = "var(--element-primary)";
    NebraskaColors["elementSecondary"] = "var(--element-secondary)";
    NebraskaColors["featureBankingAccount"] = "var(--feature-banking-account)";
    NebraskaColors["featureInvites"] = "var(--feature-invites)";
    NebraskaColors["lavanda100"] = "var(--lavanda-100)";
    NebraskaColors["lavanda200"] = "var(--lavanda-200)";
    NebraskaColors["lavanda300"] = "var(--lavanda-300)";
    NebraskaColors["lavanda400"] = "var(--lavanda-400)";
    NebraskaColors["lavanda500"] = "var(--lavanda-500)";
    NebraskaColors["lavanda600"] = "var(--lavanda-600)";
    NebraskaColors["lavanda700"] = "var(--lavanda-700)";
    NebraskaColors["lavanda800"] = "var(--lavanda-800)";
    NebraskaColors["linho500"] = "var(--linho-500)";
    NebraskaColors["monetaryNegative"] = "var(--monetary-negative)";
    NebraskaColors["monetaryPositive"] = "var(--monetary-positive)";
    NebraskaColors["neutralLink"] = "var(--neutral-link)";
    NebraskaColors["neutralOverPrimary"] = "var(--neutral-over-primary)";
    NebraskaColors["neutralPrimary"] = "var(--neutral-primary)";
    NebraskaColors["neutralPrimaryActive"] = "var(--neutral-primary-active)";
    NebraskaColors["neutralPrimaryDarken"] = "var(--neutral-primary-darken)";
    NebraskaColors["neutralPrimaryHover"] = "var(--neutral-primary-hover)";
    NebraskaColors["neutralSecondary"] = "var(--neutral-secondary)";
    NebraskaColors["neutralSecondaryDarken"] = "var(--neutral-secondary-darken)";
    NebraskaColors["oceano100"] = "var(--oceano-100)";
    NebraskaColors["oceano200"] = "var(--oceano-200)";
    NebraskaColors["oceano300"] = "var(--oceano-300)";
    NebraskaColors["oceano400"] = "var(--oceano-400)";
    NebraskaColors["oceano500"] = "var(--oceano-500)";
    NebraskaColors["oceano600"] = "var(--oceano-600)";
    NebraskaColors["oceano700"] = "var(--oceano-700)";
    NebraskaColors["oceano800"] = "var(--oceano-800)";
    NebraskaColors["ouro500"] = "var(--ouro-500)";
    NebraskaColors["preto25"] = "var(--preto-25)";
    NebraskaColors["preto60"] = "var(--preto-60)";
    NebraskaColors["preto70"] = "var(--preto-70)";
    NebraskaColors["progressAlert"] = "var(--progress-alert)";
    NebraskaColors["progressBackground"] = "var(--progress-background)";
    NebraskaColors["progressDisabled"] = "var(--progress-disabled)";
    NebraskaColors["progressNegative"] = "var(--progress-negative)";
    NebraskaColors["progressPositive"] = "var(--progress-positive)";
    NebraskaColors["riskHigh"] = "var(--risk-high)";
    NebraskaColors["riskLow"] = "var(--risk-low)";
    NebraskaColors["riskMedium"] = "var(--risk-medium)";
    NebraskaColors["selva100"] = "var(--selva-100)";
    NebraskaColors["selva200"] = "var(--selva-200)";
    NebraskaColors["selva300"] = "var(--selva-300)";
    NebraskaColors["selva400"] = "var(--selva-400)";
    NebraskaColors["selva500"] = "var(--selva-500)";
    NebraskaColors["selva600"] = "var(--selva-600)";
    NebraskaColors["selva700"] = "var(--selva-700)";
    NebraskaColors["selva800"] = "var(--selva-800)";
    NebraskaColors["staticBlack"] = "var(--static-black)";
    NebraskaColors["staticWhite"] = "var(--static-white)";
    NebraskaColors["statusAlert"] = "var(--status-alert)";
    NebraskaColors["statusAlertBackground"] = "var(--status-alert-background)";
    NebraskaColors["statusBrand"] = "var(--status-brand)";
    NebraskaColors["statusBrandBackground"] = "var(--status-brand-background)";
    NebraskaColors["statusInfo"] = "var(--status-info)";
    NebraskaColors["statusInfoBackground"] = "var(--status-info-background)";
    NebraskaColors["statusNegative"] = "var(--status-negative)";
    NebraskaColors["statusNegativeBackground"] = "var(--status-negative-background)";
    NebraskaColors["statusPositive"] = "var(--status-positive)";
    NebraskaColors["statusPositiveBackground"] = "var(--status-positive-background)";
    NebraskaColors["terracota500"] = "var(--terracota-500)";
    NebraskaColors["textAlpha"] = "var(--text-alpha)";
    NebraskaColors["textDisabled"] = "var(--text-disabled)";
    NebraskaColors["textNegative"] = "var(--text-negative)";
    NebraskaColors["textOnError"] = "var(--text-on-error)";
    NebraskaColors["textOnSuccess"] = "var(--text-on-success)";
    NebraskaColors["textOverImage"] = "var(--text-over-image)";
    NebraskaColors["textPlaceholder"] = "var(--text-placeholder)";
    NebraskaColors["textPrimary"] = "var(--text-primary)";
    NebraskaColors["textSecondary"] = "var(--text-secondary)";
    NebraskaColors["tradeLink"] = "var(--trade-link)";
    NebraskaColors["tradeOverPrimary"] = "var(--trade-over-primary)";
    NebraskaColors["tradePrimary"] = "var(--trade-primary)";
    NebraskaColors["tradePrimaryActive"] = "var(--trade-primary-active)";
    NebraskaColors["tradePrimaryDarken"] = "var(--trade-primary-darken)";
    NebraskaColors["tradePrimaryHover"] = "var(--trade-primary-hover)";
    NebraskaColors["tradeSecondary"] = "var(--trade-secondary)";
    NebraskaColors["tradeSecondaryDarken"] = "var(--trade-secondary-darken)";
    NebraskaColors["transactionError"] = "var(--transaction-error)";
    NebraskaColors["transactionInfo"] = "var(--transaction-info)";
    NebraskaColors["transactionSuccess"] = "var(--transaction-success)";
    NebraskaColors["urucum100"] = "var(--urucum-100)";
    NebraskaColors["urucum200"] = "var(--urucum-200)";
    NebraskaColors["urucum300"] = "var(--urucum-300)";
    NebraskaColors["urucum400"] = "var(--urucum-400)";
    NebraskaColors["urucum500"] = "var(--urucum-500)";
    NebraskaColors["urucum600"] = "var(--urucum-600)";
    NebraskaColors["urucum700"] = "var(--urucum-700)";
    NebraskaColors["urucum800"] = "var(--urucum-800)";
    NebraskaColors["usaLink"] = "var(--usa-link)";
    NebraskaColors["usaOverPrimary"] = "var(--usa-over-primary)";
    NebraskaColors["usaPrimary"] = "var(--usa-primary)";
    NebraskaColors["usaPrimaryActive"] = "var(--usa-primary-active)";
    NebraskaColors["usaPrimaryDarken"] = "var(--usa-primary-darken)";
    NebraskaColors["usaPrimaryHover"] = "var(--usa-primary-hover)";
    NebraskaColors["usaSecondary"] = "var(--usa-secondary)";
    NebraskaColors["usaSecondaryDarken"] = "var(--usa-secondary-darken)";
    NebraskaColors["wealthLink"] = "var(--wealth-link)";
    NebraskaColors["wealthOverPrimary"] = "var(--wealth-over-primary)";
    NebraskaColors["wealthPrimary"] = "var(--wealth-primary)";
    NebraskaColors["wealthPrimaryActive"] = "var(--wealth-primary-active)";
    NebraskaColors["wealthPrimaryDarken"] = "var(--wealth-primary-darken)";
    NebraskaColors["wealthPrimaryHover"] = "var(--wealth-primary-hover)";
    NebraskaColors["wealthSecondary"] = "var(--wealth-secondary)";
    NebraskaColors["wealthSecondaryDarken"] = "var(--wealth-secondary-darken)";
    NebraskaColors["themeLink"] = "var(--theme-link)";
    NebraskaColors["themeOverPrimary"] = "var(--theme-over-primary)";
    NebraskaColors["themePrimary"] = "var(--theme-primary)";
    NebraskaColors["themePrimaryActive"] = "var(--theme-primary-active)";
    NebraskaColors["themePrimaryDarken"] = "var(--theme-primary-darken)";
    NebraskaColors["themePrimaryHover"] = "var(--theme-primary-hover)";
    NebraskaColors["themeSecondary"] = "var(--theme-secondary)";
    NebraskaColors["themeSecondaryDarken"] = "var(--theme-secondary-darken)";
    NebraskaColors["primary"] = "var(--primary)";
    NebraskaColors["overPrimary"] = "var(--over-primary)";
})(NebraskaColors = exports.NebraskaColors || (exports.NebraskaColors = {}));
